import React from "react"
import { Link, graphql, navigate } from "gatsby"
import {
  EListingCardLayouts,
  ListingCard,
} from "@organic-return/foundation-react/src/components/Listing/ListingCard"
import { EListingVitalsLayout } from "@organic-return/foundation-react/src/components/Listing/ListingVitals"
import { SearchCompact } from "@organic-return/foundation-react/src/components/Search/SearchCompact"
import { SiteContext } from "../common/SiteContext"

const ListingSearchCompact = (props: any) => {
  
  let initialFilter = props.filter?.query

  if (initialFilter) {
    initialFilter = initialFilter.replace(/\+/g, '%20')
    initialFilter = decodeURIComponent(initialFilter)
  }

  let listings = props.listings;
  
  // Configurable results per page defaults to 20
  let pageSize = props.pageSize || 20
  return (
    <SiteContext.Consumer>{
      value => {
        return (
          <SearchCompact
            index={listings}
            initialFilter={initialFilter}
            pageSize={pageSize}
            showCount={true}
            useMap={true}
            mapClick={item => navigate(item.path)}
            renderItem={(item, index) => {
              return (
                <ListingCard
                  key={index}
                  listing={item}
                  layout={EListingCardLayouts.vertical}
                  className={`w-full h-full max-w-full`}
                  maxWidthImage={640}
                  linkImage={true}
                  linkFunc={props => {
                    return (
                      <Link
                        to={props.href ?? ""}
                        className={`text-inherit ${props.className}`}
                        key={props.key}
                        title={props.title}
                      >
                        {props.children}
                      </Link>
                    )
                  }}
                  {...value.globalListingCardProps}
                  vitalsLayout={
                    props.cardLayout ||
                    EListingVitalsLayout.column2Border1
                  }
                />
              )
            }}
            title={props.title}
            preRenderItem={(item, index) => {
              return (
                <a key={index} href={item.path}></a>
              )
            }}
            {...value.listingSearchCompactProps}
          />
        )
      }}
    </SiteContext.Consumer>
  )
}

export default ListingSearchCompact

export const query = graphql`
fragment DrupalListingSearchCompactContent on DrupalListingSearchCompact {
    id
    cardLayout
    filter {
      query
    }
    pageSize
    title
    listings {
      id
      baths
      address {
        city
        street1
        county
        postal
        text
        street2
        state
      }
      beds
      lotacres
      majorArea
      minorArea
      mlsID
      price
      sqft
      status
      statusTS
      subType
      subdivision
      neighborhood
      exclusive
      features
      flags
      type
      defaultImage {
        dimensions
        url
      }
      path
      location {
        lat
        lng
      }
      hasWaterfront
      hasWaterViews
      hasBeachfront
      hasGolfCourseView
      hasOpenHouse
      hideOnMap
      propertyStyles
      garageSpaces
      hasVirtualTour
      vacationRentable
      amenities
      lifestyles
      rooms
      parkingFeatures
      newlyBuilt
      agent {
        mlsID
      }
      office {
        mlsID
      }
      realEstateOwned
      shortSale
      onMktTS
      landTenure
      isDistinctive
      complexName
      descriptionShort
    }
}
`